import React from 'react';

import { Route, Switch } from 'react-router-dom'
import './index.css';
import * as image from './assets'
import CustomerCheckout from './pages/CustomerCheckout'
import SellerCheckout from './pages/SellerCheckout'

function App() {

  return (
    <div className="App">
      <Switch>
        <Route path="/" exact component={CustomerCheckout} />
        {/* <Route path="/:token" exact component={CustomerCheckout} /> */}
        <Route path="/seller/payment/" exact component={SellerCheckout} />
      </Switch>
    </div>
  );
}

export default App;
